import { orange, pink, red } from '@material-ui/core/colors';
import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  cellRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#eeededde',
    },
  },
  border: {
    border: '1px solid #E0E0E0',
  },
  tableContainer: {
    '& .MuiTableHead-root': {
      fontWeight: 700,
    },
  },
  tabs: {
    width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
  },
  label: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 14,
  },

  sync: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    flexGrow: 1,
    margin: theme.spacing(1),
    color: 'red',
    padding: theme.spacing(1),
  },
  btnAdd: {
    textTransform: 'capitalize',
    boxShadow: theme.shadows[0],
    padding: theme.spacing(0, 1),
    marginLeft: theme.spacing(2),
    minWidth: 64,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgb(0, 87, 178)',
      boxShadow:
        '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
    },
    '& svg': {
      fill: '#ffffff',
    },
  },
  cellTitle: {
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '50%',
  },
  cellHead: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '25%',
    textTransform: 'uppercase',
  },
  cellContent: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)',
    width: '25%',
  },
  btnContainer: {
    margin: '0 0 24px 0 ',
    height: '50px',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  btn: {
    padding: '12px 24px',
    textTransform: 'capitalize',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  noBorder: {
    border: 'none',
  },
  dataGrid: {
    width: '100%',
    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected ': {},
    '& .MuiDataGrid-root .MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .row-background-error': {
      backgroundColor: red[50],
      '&:hover': {
        backgroundColor: red[100],
      },
    },
    '& .row-background-alert': {
      backgroundColor: pink[50],
      '&:hover': {
        backgroundColor: pink[100],
      },
    },
    '& .row-background-transaction': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255, 80, 95, 0.04)',
      },
    },
    '& .cell-text-color-error': {
      color: pink[700],
    },
    '& .cell-text-color-alert': {
      color: orange[700],
    },
    '& .cell-text-color-transaction': {
      color: 'black',
      fontWeight: '500',
      textTransform: 'capitalize',
    },
    '& .MuiDataGrid-root .MuiDataGrid-colCellTitle': {
      color: 'black',
      fontWeight: '700',
      textTransform: 'capitalize',
    },
  },
  root: {
    position: 'relative',
    height: '50px',
    marginBottom: '24px',
  },
  dropdown: {
    position: 'absolute',
    zIndex: 1,
    top: 40,
    right: 0,
    width: 270,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 6px 6px rgba(0, 0, 0, 0.26), 0px 10px 20px rgba(0, 0, 0, 0.19)',
    borderRadius: 4,
  },
  selectItem: {
    padding: theme.spacing(1, 1.2),
    '& svg': {
      marginRight: theme.spacing(1.2),
    },
    '& img': {
      marginRight: theme.spacing(1.2),
    },
  },
}));

export const useStylesV2 = makeStyles((theme: Theme) => ({}), {
  index: 1,
});
